// An illustrative output price, deliberately not any one vendor's: the demo is about the sum, not the rate.
export const usdPerMillionTokens = 15;

/**
 * Formats a US dollar amount for the demo's readings.
 *
 * @param language - The viewer's language.
 * @param amount - The amount in dollars.
 * @param digits - How many decimal places to show.
 * @returns The amount as currency.
 */
export function formatDemoMoney(language: string, amount: number, digits: number): string {
  return new Intl.NumberFormat(language, { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(amount);
}
